import styled from 'styled-components'
import { themeContract } from './M023.theme.contract'

const Container = styled.div`
  margin-bottom: ${(props) => props.theme.size.spacing.lg};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  background-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].background.color]};
`
export { Container }
